// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 1H7.58579L3 5.58579V23H21V1ZM11.5 16.9876V11.0059H10.5V9.00586H13.5V16.9876H11.5Z"}}]};

const SimCard1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sim-card-1-filled',
    ref,
    icon: element,
  },
));

SimCard1FilledIcon.displayName = 'SimCard1FilledIcon';

export default SimCard1FilledIcon;
